import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AhmedElshahatJobService } from '../../../../../services/ahmed-elshahat-job';

@Component({
  selector: 'app-add-skills',
  templateUrl: './add-skills.component.html',
  styleUrl: './add-skills.component.scss'
})
export class AddSkillsComponent implements OnInit {

  data!: FormGroup;

  contentReady: boolean = false;
  isSubmitting: boolean = false;

  skills: any[] = [];

  constructor(
    private fb: FormBuilder,
    private jobService: AhmedElshahatJobService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.getSkills();
  }

  createForm(): void {
    this.data = this.fb.group({
      name_en: ['', Validators.required],
      name_ar: ['', Validators.required],
      slug_en: [''],
      slug_ar: [''],
      category: ['', Validators.required],
    });
  }

  getSkills(): void {
    this.contentReady = false;

    this.jobService.getSkills({
      per_page: 1000
    }).subscribe({
      next: (res: any) => {
        this.skills = res?.data?.data || [];
        this.contentReady = true;
      },
      error: (err: any) => {
        console.log(err);
        this.contentReady = true;
      }
    });
  }

  onSubmit(): void {
    if (this.data.invalid) {
      this.data.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const formValue = this.data.value;

    const payload = {
      name_en: formValue.name_en,
      name_ar: formValue.name_ar,
      slug_en: formValue.slug_en ? formValue.slug_en : null,
      slug_ar: formValue.slug_ar ? formValue.slug_ar : null,
      category: formValue.category
    };

    this.jobService.addSkill(payload).subscribe({
      next: () => {
        this.isSubmitting = false;

        this.data.reset({
          name_en: '',
          name_ar: '',
          slug_en: '',
          slug_ar: '',
          category: ''
        });

        this.getSkills();
      },
      error: (err: any) => {
        console.log(err);
        this.isSubmitting = false;

        if (err?.error?.errors?.name_en) {
          alert(err.error.errors.name_en[0]);
        } else if (err?.error?.errors?.name_ar) {
          alert(err.error.errors.name_ar[0]);
        } else if (err?.error?.errors?.slug_en) {
          alert(err.error.errors.slug_en[0]);
        } else if (err?.error?.errors?.slug_ar) {
          alert(err.error.errors.slug_ar[0]);
        } else if (err?.error?.message) {
          alert(err.error.message);
        } else {
          alert('حدث خطأ أثناء إضافة المهارة');
        }
      }
    });
  }

  deleteSkill(id: any): void {
    const confirmDelete = confirm('هل أنت متأكد من حذف هذه المهارة؟');

    if (!confirmDelete) {
      return;
    }

    this.jobService.deleteSkill(id).subscribe({
      next: () => {
        this.getSkills();
      },
      error: (err: any) => {
        console.log(err);
        alert('حدث خطأ أثناء حذف المهارة');
      }
    });
  }

  getCategoryName(category: string): string {
    switch (category) {
      case 'education':
        return 'تعليم';

      case 'experience':
        return 'خبرة';

      case 'certificate':
        return 'شهادة';

      case 'language':
        return 'لغة';

      case 'technical':
        return 'مهارة تقنية';

      case 'soft_skill':
        return 'مهارة شخصية';

      case 'other':
        return 'أخرى';

      default:
        return 'غير محدد';
    }
  }
}